/* eslint-disable react/react-in-jsx-scope */
import {
  Area,
  AreaChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";
import "./bigChartBox.css";

type Props = {
  title: string;
  color: string;
  dataKey: string;
  chartData: object[];
};

const data = [
  {
    name: "Sun",
    books: 4000,
    clothes: 2400,
    electronic: 2400,
  },
  {
    name: "Mon",
    books: 3000,
    clothes: 1398,
    electronic: 2210,
  },
  {
    name: "Tue",
    books: 2000,
    clothes: 9800,
    electronic: 2290,
  },
  {
    name: "Wed",
    books: 2780,
    clothes: 3908,
    electronic: 2000,
  },
  {
    name: "Thu",
    books: 1890,
    clothes: 4800,
    electronic: 2181,
  },
  {
    name: "Fri",
    books: 2390,
    clothes: 3800,
    electronic: 2500,
  },
  {
    name: "Sat",
    books: 3490,
    clothes: 4300,
    electronic: 2100,
  },
];

const BigChartBox = (props: Props) => {
  return (
    <div className="bigChartBox">
      <h1>{props.title}</h1>
      <div className="chart">
        <ResponsiveContainer width="100%" height="100%">
          <AreaChart
            data={props.chartData}
            margin={{
              top: 10,
              right: 30,
              left: 0,
              bottom: 0,
            }}
          >
            <XAxis dataKey={props.xaxisKey} tick={{ fill: '#ffffff' }} tickLine={{ stroke: '#4c6676' }}
              axisLine={{ stroke: '#EAF0F4' }} 
              style={{
                fontSize: '14px',
                // fontFamily: 'Times New Roman',
              }}
            />
            <YAxis tick={{ fill: '#ffffff' }} tickLine={{ stroke: '#688394' }}
              axisLine={{ stroke: '#EAF0F4' }}
            />
            <Tooltip
              contentStyle={{ background: "#2a3447", borderRadius: "5px" }}
              // labelStyle={{ display: "none" }}
              cursor={{fill:"none"}}
            />
            {/* <Area
              type="monotone"
              dataKey="electronic"
              stackId="1"
              stroke="#8884d8"
              fill="#8884d8"
            /> */}
            <Area
              type="monotone"
              dataKey={props.yaxisKey1}
              stackId="1"
              stroke="#82ca9d"
              fill="#82ca9d"
            />
            <Area
              type="monotone"
              dataKey={props.yaxisKey2}
              stackId="1"
              stroke="#ffc658"
              fill="#ffc658"
            />
          </AreaChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default BigChartBox;
